/** The zInspector write requests a screen would send, for review while the API can't take them. */
import { Check, Copy } from "lucide-react";
import { useState } from "react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

import type { ZiWriteRequest } from "../providers/zinspector/newClient";

export const RequestPreview = ({
  requests,
  note,
}: {
  requests: ZiWriteRequest[];
  note: string;
}) => {
  const [copied, setCopied] = useState(false);
  const text = requests
    .map(
      (request) =>
        `${request.method} /api${request.path}\n${JSON.stringify(request.body, null, 2)}`,
    )
    .join("\n\n");

  const copy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
  };

  return (
    <Card>
      <CardContent className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <h2 className="text-lg font-semibold">
            {requests.length === 1
              ? "Request zCRM would send"
              : `Requests zCRM would send (${requests.length})`}
          </h2>
          <Button type="button" variant="outline" size="sm" onClick={copy}>
            {copied ? <Check /> : <Copy />}
            {copied ? "Copied" : "Copy"}
          </Button>
        </div>
        <Alert>
          <AlertDescription>{note}</AlertDescription>
        </Alert>
        {requests.map((request) => (
          <div key={request.path} className="flex flex-col gap-1">
            <code className="text-sm font-semibold">
              {request.method} /api{request.path}
            </code>
            <pre className="text-xs bg-muted rounded-md p-3 overflow-x-auto">
              {JSON.stringify(request.body, null, 2)}
            </pre>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
